import { useEffect, useState } from "react";
import { ErrorX, store } from "static";
import { VStack, HStack } from "Components/LabIZO/Stackizo";
import { DATA_LINK, backendConnector } from "connectors";
import Formizo from "Components/LabIZO/Formizo";
import { schema } from "./schema";
import { Typography } from "@mui/material";
interface IModelConfig {
  parameter: object;
  id: string;
  name: string;
  model: string;
  url?: string;
}
export type IndexTimeframeType = "YYYYMM" | "YYYYMMDD";

export interface IESConvConfig {
  type: "ElasticSearch";
  username: string;
  password: string;
  url: string;
  index: string;
  indexTimeframe: IndexTimeframeType;
}

export interface ICouchConvConfig {
  type: "CouchDB";
  BASE: "http://" | "https://";
  USERNAME: string;
  PASSWORD: string;
  URL: string;
}
export type IConvDBConfig = IESConvConfig | ICouchConvConfig;

const SysModel = () => {
  const [modelOption, setModelOption] = useState<{ models: IModelConfig[] }>();

  useEffect(() => {
    getModelInfo();
  }, []);

  const handleSubmit = async (modelDocs: { models: IModelConfig[] }) => {
    try {
      const res = await backendConnector.post(DATA_LINK.SYSModelEdit, modelDocs);
      if (res.Success) {
        store.Alert("System Model updated successfully", "success");
      } else {
        store.Alert("System Model update fails.", "error");
      }
    } catch (e: any) {
      store.Alert(ErrorX.Handle(e), "error");
    }
  };

  const getModelInfo = async () => {
    const { payload } = await backendConnector.post(DATA_LINK.SYSModelInfo, {});
    setModelOption(payload);
  };
  const renderModelSetting = () => {
    return (
      <Formizo
        //
        schema={schema}
        buttons={["Revert", "Submit"]}
        onSubmit={handleSubmit}
        defaultValue={modelOption}
      />
    );
  };

  return (
    <HStack justifyContent="flex-start" height="100%" gap={3} paddingX={4}>
      <VStack width="100%">
        {renderModelSetting()}
        <Typography variant="body2" color="textSecondary">
          Note: After each update of the model settings, the first one will automatically be set as the primary model.
        </Typography>
      </VStack>
    </HStack>
  );
};
export { schema };
export default SysModel;
